export const onUnauthenticatedPages = function () {
  const unauthenticatedPages = [
    'Login',
    'ResetPassword',
    'InitiateResetPassword',
    'FrontPage',
    'ConfirmEmail',
    'TryModel',
  ];
  return unauthenticatedPages.includes(this.$route.name);
};

export const onProfilePages = function () {
  const profilePages = [
    'MyProfile',
    'ProfileChooseAvatar',
    'ProfileChangePassword',
    'ProfileNotifications',
    'ProfileAuthentication',
    'ProfileTrustedDevices',
    'ProfileApiTokens',
    'ProfileSegAny',
    'ProfileUserLimits',
    'ProfileUpgradeSubscription',
    'ProfilePaymentOverview',
    'SuperAdminDashboard',
    'SuperAdminSlowQueries',
    'SuperAdminSlowRoutes',
    'Success',
    'Error',
  ];
  return profilePages.includes(this.$route.name);
};

export const onProjectsPage = function () {
  return this.$route.name === 'Projects';
};

export const onPasswordResetPage = function () {
  return this.$route.name === 'ResetPassword';
};
